const CURRICULUM_FILE_ACCEPT = '.pdf,.doc,.docx';

export function normalizeCurriculumForApi(outline) {
  if (!Array.isArray(outline)) return [];
  return outline
    .filter((section) => section && typeof section === 'object')
    .map((section, index) => ({
      id: String(section.id || `section-${index + 1}`),
      title: String(section.title || `Section ${index + 1}`),
      color: String(section.color || 'blue'),
      topics: Array.isArray(section.topics)
        ? section.topics.map((topic) => String(topic || '')).filter(Boolean)
        : [],
    }));
}

/** JSON body for create/update without curriculum file upload. */
export function buildCourseRequestData(fields, curriculumFile = null) {
  const payload = {
    ...fields,
    curriculum_outline: normalizeCurriculumForApi(fields.curriculum_outline ?? []),
  };

  if (!curriculumFile) {
    return payload;
  }

  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (key === 'curriculum_outline') {
      formData.append(key, JSON.stringify(value));
      return;
    }
    if (value !== undefined && value !== null && value !== '') {
      formData.append(key, value);
    }
  });
  if (curriculumFile) {
    formData.append('course_curriculam', curriculumFile);
  }
  return formData;
}

export { CURRICULUM_FILE_ACCEPT };
